import { ApiImageClient } from "@/api";

async function apiUserGetCompany({
  id,
  params = {},
}: {
  id: string;
  params?: Record<string, any>;
}) {
  try {
    let queryParams: Record<string, any> = {};

    if (params["populate[employees][populate]"]) {
      queryParams["populate[employees][populate]"] = "profile";
    } else {
      queryParams.populate = "*";
    }

    const queryString = new URLSearchParams(queryParams).toString();

    const result = await ApiImageClient.get(
      `/companies/${id}?${queryString}`,
    ).then(({ data }) => data);

    return result;
  } catch (e) {
    console.error(
      "apiUserGetCompany_Error",
      e.response?.data || e.message || e,
    );
    return e;
  }
}

async function apiUserGetCompanies(token: string) {
  try {
    const result = await ApiImageClient.get(`/companies?populate=*`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then(({ data }) => data);

    return result;
  } catch (e) {
    console.error("apiUserGetCompanies_Error", e);
    return e;
  }
}

async function apiUserPostCompany({ data }: { data: any }) {
  try {
    const result = await ApiImageClient.post(`/companies/`, { data }).then(
      ({ data }) => data,
    );
    return result;
  } catch (e) {
    console.error("apiUserPostCompany_Error", e);
    return e;
  }
}

async function apiUserPutCompany({ data, id }: { data: any; id: string }) {
  try {
    const result = await ApiImageClient.put(`/companies/${id}`, { data }).then(
      ({ data }) => data,
    );
    return result;
  } catch (e) {
    console.error("apiUserPostCompany_Error", e);
    return e;
  }
}

export {
  apiUserGetCompany,
  apiUserGetCompanies,
  apiUserPostCompany,
  apiUserPutCompany,
};
